import {
  type AIMessageActionKey,
  ALL_AI_MESSAGE_ACTION_KEYS,
} from 'bundles/enterprise-admin-messaging-v2/utils/aiMessageActions';

/**
 * Returns `count` keys starting at `offset`, wrapping around the registry.
 * `offset` must be ≥ 0 (callers ensure this via `deserializeOffset`).
 */
export const sliceWithWrap = (offset: number, count: number): AIMessageActionKey[] => {
  const total = ALL_AI_MESSAGE_ACTION_KEYS.length;
  if (total === 0) return [];
  const safeCount = Math.min(count, total);
  const start = offset % total;
  const out: AIMessageActionKey[] = [];
  for (let i = 0; i < safeCount; i += 1) {
    const key = ALL_AI_MESSAGE_ACTION_KEYS[(start + i) % total];
    if (key !== undefined) out.push(key);
  }
  return out;
};
